const { relative } = require('path');

module.exports = {
  mode: 'jit',
  content: {
    relative: true,
    files: [
      './pages/**/*.{js,ts,jsx,tsx}',
      './components/**/*.{js,ts,jsx,tsx}',
    ],
  },
  theme: {
    container: {
      screens: {
        sm: '640px',
        md: '768px',
        lg: '1024px',
        xl: '1280px',
        '2xl': '1536px',
      },
    },
    fontFamily: {
      display: ['Inter', 'system-ui'],
      sans: [
        'system-ui',
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        '"Noto Sans"',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
        '"Noto Color Emoji"',
      ],
      serif: [
        'Roboto Slab',
        'Georgia',
        'Cambria',
        '"Times New Roman"',
        'Times',
        'serif',
      ],
      mono: [
        'Menlo',
        'Monaco',
        'Consolas',
        '"Liberation Mono"',
        '"Courier New"',
        'monospace',
      ],
    },
    fontSize: {
      base: ['16px', '24px'],
      // body
      '3xl': ['28px', '40px'],
      '2xl': ['24px', '32px'],
      xl: ['20px', '28px'],
      lg: ['18px', '24px'],
      md: ['16px', '24px'],
      sm: ['14px', '20px'],
      xs: ['12px', '20px'],
      // heading
      'h-3xl': ['64px', '80px'],
      'h-2xl': ['48px', '60px'],
      'h-xl': ['40px', '48px'],
      'h-lg': ['32px', '40px'],
      'h-md': ['24px', '32px'],
      'h-sm': ['20px', '24px'],
      'h-xs': ['18px', '24px'],
      'h-2xs': ['16px', '24px'],
      'h-3xs': ['14px', '20px'],
    },
    extend: {
      screens: {
        custom900: '900px',
        custom1200: '1200px',
      },
      width: {
        15.1: '15.1rem',
      },
      colors: {
        transparent: 'transparent',
        agility: '#222',
        gray: {
          lightest: '#fff',
          50: '#F4F4F4',
          100: '#F1F1F1',
          200: '#E7E7E7',
          300: '#D7D7D7',
          400: '#B4B4B4',
          500: '#949494',
          600: '#6B6B6B',
          700: '#585858',
          800: '#3A3A3A',
          900: '#19191D',
        },
        primary: {
          100: '#a273ff',
          200: '#935bff',
          300: '#8344ff',
          400: '#742cff',
          500: '#6415FF',
          600: '#5a13e6',
          700: '#5011cc',
          800: '#460fb3',
          900: '#3c0d99',
        },
        secondary: {
          100: '#7c8ba1',
          200: '#667892',
          300: '#506582',
          400: '#3a5173',
          500: '#243E63',
          600: '#203859',
          700: '#1d324f',
          800: '#192b45',
          900: '#16253b',
        },
        success: {
          50: '#E5FAE8',
          other: '#00C4B3',
        },
        white: '#fff',
        blue: '#005581',
        'blue-tint': '#E4F1F4',
        'dark-blue': '#133D60',
        yellow: '#F4AA00',
        'yellow-tint': '#FFF8E9',
        'dark-yellow': '#C38200',
        'light-blue': '#4298B5',
        orange: '#E26D2D',
        'orange-tint': '#FCEEE6',
        purple: '#6A4059',
        'purple-tint': '#FFEBF7',
        green: '#B7BF10',
        evergreen: '#148E00',
        teal: '#00806B',
      },
    },
  },
  variants: {
    extend: {},
  },
  plugins: [require('@tailwindcss/typography')],
  safelist: ['text-yellow'],
};
